import React from "react"

import { useMultiFormatCollection } from "../../hooks/multiFormatCollection"
import useLocalCollectionHandler from "../../hooks/useLocalCollectionHandler"
import { collectionFullSlugPrefixer } from "../../helper/collectionFullSlugPrefixer"
import MCardGrid from "../blocks/m_cardgrid"
import MFeedMasonry from "../blocks/m_feed_masonry"

/**
 * This is the switch component for the multi format slider.
 * It ensures the data that is forwarded to the rendering component
 * was handled by the multi format collection hook.
 */
const MMultiFormatStream = (props) => {
  const { uid } = props.data
  const prefixedCollection = collectionFullSlugPrefixer(props.data.collection)
  const collection = useMultiFormatCollection(
    prefixedCollection,
    props.data.limit,
    props.data.sorting
  )

  const {
    collectionForPage,
    hasNextPage,
    totalCount,
    availableFilterOptions,
    setSelectedFilterOptions,
    handleNextPage,
  } = useLocalCollectionHandler(
    collection,
    props.data.items_per_page,
    props.data.filter_by,
    1,
    props.data.plugin.tx_headless_selected_categories
  )

  const dataCopy = {
    ...props.data,
    collection,
  }
  const cardGridProps = {
    ...props,
    data: dataCopy,
  }

  // empty result state: totalCount is zero
  if (collection.length === 0) {
    return (
      <section
        className="m-Empty"
        data-info={`MultiFormatStream: empty local collection in component ${uid}`}
      ></section>
    )
  }

  const stream_type = "m-cardgrid"
  //const stream_type = "m-feed-masonry"

  switch (stream_type) {
    case "m-feed-masonry":
      return (
        <MFeedMasonry
          {...cardGridProps}
          collectionForPage={collectionForPage}
          hasNextPage={hasNextPage}
          totalCount={totalCount}
          availableFilterOptions={availableFilterOptions}
          setSelectedFilterOptions={setSelectedFilterOptions}
          handleNextPage={handleNextPage}
        />
      )
    case "m-cardgrid":
      return (
        <MCardGrid
          {...cardGridProps}
          collectionForPage={collectionForPage}
          hasNextPage={hasNextPage}
          totalCount={totalCount}
          availableFilterOptions={availableFilterOptions}
          setSelectedFilterOptions={setSelectedFilterOptions}
          handleNextPage={handleNextPage}
        />
      )
    default:
      return (
        <MCardGrid
          {...cardGridProps}
          collectionForPage={collectionForPage}
          hasNextPage={hasNextPage}
          totalCount={totalCount}
          availableFilterOptions={availableFilterOptions}
          setSelectedFilterOptions={setSelectedFilterOptions}
          handleNextPage={handleNextPage}
        />
      )
  }
}

export default MMultiFormatStream
